import * as actionTypes from "../actionTypes";
import initialState from "reducers/initialState";
import { combineReducers } from "redux";

const scoringReducer = (state = initialState.scoringGrid, action) => {
  switch (action.type) {
    case actionTypes.LOAD_SCORING_GRIDS_STARTED: {
      const { id } = action;
      let result = { ...state };
      result[id] = { ...state[id], loading: true, loaded: false };
      return result;
    }

    case actionTypes.LOAD_SCORING_GRIDS_SUCCESS: {
      const { id } = action;
      let result = { ...state };
      result[id] = { ...state[id], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case actionTypes.LOAD_SCORING_GRIDS_FAILED: {
      const { id } = action;
      let result = { ...state };
      result[id] = { ...result[id], loading: false, loaded: false };
      return result;
    }

    default:
      return state;
  }
};

export default combineReducers({
  list: scoringReducer
});
